export var UpdatedCustomizedReportError;
(function (UpdatedCustomizedReportError) {
})(UpdatedCustomizedReportError || (UpdatedCustomizedReportError = {}));
var UpdateCustomizedReportRequest = /** @class */ (function () {
    function UpdateCustomizedReportRequest(id, report) {
        this.knownErrorCodes = Object.values(UpdatedCustomizedReportError);
        this.method = 'put';
        var expectedBody = {
            name: report.name,
            description: report.description || '',
            historized: report.historized,
            reportSettings: report.reportSettings,
        };
        this.path = "my/customized-reports/".concat(id);
        this.body = JSON.stringify(expectedBody);
    }
    return UpdateCustomizedReportRequest;
}());
export { UpdateCustomizedReportRequest };
